/**
 * Verifies if an application can use DOM.
 */ export function canUseDOM() {
    return(// eslint-disable-next-line deprecation/deprecation, no-restricted-globals
    typeof window !== 'undefined' && !!(window.document && window.document.createElement));
}
